import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {modalClose} from "../genericFunctions";
import AssignTechnicianToAdministrative, {
    AssignTechnicianToAdministrativeProps
} from "../../../pages/program/administrative/components/AssignTechnicianToAdministrative";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";


interface OwnProps extends SlideOverProps, AssignTechnicianToAdministrativeProps {
}

type Props = OwnProps;

// @ts-ignore
const AssignTechnicianToAdministrativeModal = NiceModal.create<Props>(({administrative, header, onClose}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver title={header} onClose={handleClose} open={modal.visible} afterClose={modal.remove}>
            <AssignTechnicianToAdministrative administrative={administrative}/>
        </SlideOver>
    )
})

export default AssignTechnicianToAdministrativeModal;
